"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var api_1 = require("../../utils/api");
var toolkit_1 = require("@reduxjs/toolkit");
var config_1 = __importStar(require("../../config"));
var getParentalSettings_1 = __importDefault(require("./queries/getParentalSettings"));
var setParentalControl_1 = __importDefault(require("./queries/setParentalControl"));
var setParentalPin_1 = __importDefault(require("./queries/setParentalPin"));
var setParentallyApprovedClassification_1 = __importDefault(require("./queries/setParentallyApprovedClassification"));
var enterParentalPin_1 = __importDefault(require("./queries/enterParentalPin"));
var validateParentalPin_1 = __importDefault(require("./queries/validateParentalPin"));
var resetParentalPin_1 = __importDefault(require("./queries/resetParentalPin"));
var selectors_1 = require("../customer/selectors");
var constants_1 = require("./constants");
exports.clearParentalPinValidationResult = function () { return function (dispatch, getState) {
    var userProfileId = selectors_1.selectedProfileId(getState());
    return dispatch(toolkit_1.createAction(constants_1.CLEAR_VALIDATE_PARENTAL_PIN)({ userProfileId: userProfileId }));
}; };
// eslint-disable-next-line import/prefer-default-export
exports.fetchParentalSettings = function () {
    return api_1.createApiAction(constants_1.FETCH_USER_PARENTAL_SETTINGS, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: getParentalSettings_1.default,
        },
        graphQL: true,
        authenticated: true,
    });
};
exports.setParentalPin = function (pin) {
    return api_1.createApiAction(constants_1.SET_PARENTAL_PIN, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: setParentalPin_1.default,
            variables: { pin: pin },
        },
        authenticated: true,
        graphQL: true,
        onSuccess: function (successDispatch) {
            successDispatch(exports.clearParentalPinValidationResult());
        },
    });
};
exports.setParentalControl = function (enabled) {
    return api_1.createApiAction(constants_1.SET_PARENTAL_CONTROLS, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: setParentalControl_1.default,
            variables: { enabled: enabled },
        },
        meta: { enabled: enabled },
        authenticated: true,
        graphQL: true,
        onSuccess: function (dispatch) {
            dispatch(exports.clearParentalPinValidationResult());
        },
    });
};
exports.enterParentalPin = function (enteredPin) {
    return api_1.createApiAction(constants_1.ENTER_PARENTAL_PIN, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: enterParentalPin_1.default,
            variables: { enteredPin: enteredPin },
        },
        authenticated: true,
        graphQL: true,
    });
};
exports.validateParentalPin = function (enteredPin) { return function (dispatch, getState) {
    var userProfileId = selectors_1.selectedProfileId(getState());
    return dispatch(api_1.createApiAction(constants_1.VALIDATE_PARENTAL_PIN, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: validateParentalPin_1.default,
            variables: { enteredPin: enteredPin },
        },
        authenticated: true,
        graphQL: true,
        meta: { lastEnteredPin: enteredPin, userProfileId: userProfileId },
    }));
}; };
exports.resetParentalPin = function () {
    return api_1.createApiAction(constants_1.RESET_PARENTAL_PIN, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: resetParentalPin_1.default,
        },
        authenticated: true,
        graphQL: true,
    });
};
exports.setParentalllyApprovedClassification = function (code) {
    return api_1.createApiAction(constants_1.SET_PARENTALLY_APPROVED_CLASSIFICATION, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: setParentallyApprovedClassification_1.default,
            variables: { code: code },
        },
        meta: { code: code },
        authenticated: true,
        graphQL: true,
        onSuccess: function (successDispatch) {
            successDispatch(exports.clearParentalPinValidationResult());
        },
    });
};
//# sourceMappingURL=actions.js.map